import {FaAward} from 'react-icons/fa'
import {TbBooks} from 'react-icons/tb'

import {BiHappyHeartEyes} from 'react-icons/bi'

const data=[

    {id:1,icon:<TbBooks/>, title:'Frontend Development', desc:'2+ Years Experience'},
    {id:2,icon:<BiHappyHeartEyes/>, title:'Backend Development', desc:'1.5 Years Experience'} ,
    {id:3,icon:<FaAward/>, title:'Internships Completed', desc:'5+ Internship Completed'},
 
]

export default data;